
<template>
    <div>
      <div class="row">
        <div class="col">
          <div>
            <b-button @click="modalShow = !modalShow" class="float-left" style="background:#00467f;">Nuova</b-button>
            <b-modal v-model="modalShow"  size="lg">
              <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm"  style="background:#00467f;" @click="close()">X</b-button>
                <h3 style="color:black;padding-left:40px">Nuova Attività</h3>
              </template>
              <template>
                <div class="card-text" style="padding-left:40px;padding-right:40px">
                  <p><label style="margin-right:35px">Oggetto: </label><input type="textarea" rows="10" size="60" v-model="object"></p>
                  <p><label style="margin-right:13px;vertical-align: text-top;">Descrizione: </label><textarea rows="4" cols="59" style="vertical-align: text-top;" v-model="description"></textarea><!--<input type="textarea" rows="10" size="60">--></p>
                  <hr>
                  <p>Priorità:
                    <select v-model="priority_selected">
                      <option value="bassa">Bassa</option>
                      <option value="normale">Normale</option>
                      <option value="alta">Alta</option>
                    </select>
                    <input type="checkbox" id="privata" value="privata" v-model="checkPrivate" style="margin-right:5px; margin-left:15px;">
                    <label for="privata">Privata</label>
                  </p>
                  <hr>
                  <div>
                    <div class="row">
                      <div class="col">
                        <p><label style="margin-right:5px;">Data Inizio: </label><input type="date" v-model="startDate" size="40"></p>
                      </div>
                      <div class="col">
                        <p><label style="margin-right:5px;margin-left:15px">Data Consegna: </label><input type="date" v-model="endDate" size="40" style="margin-left:3px"></p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <p>
                          <label style="margin-right:35px">Stato: </label>
                          <select v-model="status_selected" style="margin-left:3px">
                            <option value="daIniziare">Da Iniziare</option>
                            <option value="inLavorazione">In Lavorazione</option>
                            <option value="completato">Completato</option>
                            <option value="inAttesa">In Attesa</option>
                            <option value="rinviato">Rinviato</option>
                          </select>
                        </p>
                      </div>
                      <div class="col">
                        <p><label style="margin-right:5px;">% Completamento: </label><input type="number" v-model="percentageComplete"></p>
                      </div>
                    </div>
                    <hr>
                    <input type="checkbox" id="promemoria" value="promemoria" v-model="reminderCheck" style="margin-right:5px;">
                    <p style="display:inline"><label for="promemoria" style="margin-right:25px">Promemoria</label></p><p v-if="reminderCheck" style="display:inline"><input type="datetime-local" v-model="reminderDate" style="magin-left:15px"/></p>
                    <hr>
                    <p>
                      <label style="margin-right:15px">Partecipanti:</label>
                      <ul class="senza-punto"><!--  v-for="" -->
                        <li style="display: inline-block;margin-right:5px"><input type="checkbox" id="cb1" value="cb1" style="margin-right:5px" v-model="check_partecipanti"><label id="cb1" for="cb1"><span style="border:1px solid; border-radius: 5px"><i style="margin-left:5px;margin-right:5px;margin-top:5px;margin-bottom:5px">Mario</i></span></label></li>
                        <li style="display: inline-block;margin-right:5px"><input type="checkbox" id="cb2" value="cb2" style="margin-right:5px" v-model="check_partecipanti"><label id="cb2" for="cb2"><span style="border:1px solid; border-radius: 5px"><i style="margin-left:5px;margin-right:5px;margin-top:5px;margin-bottom:5px">Luigi</i></span></label></li>

                        <li></li>
                        <!-- 
                          <input type="checkbox"  v-bind:id="valori.id"  v-bind:value="valori.value" name="check_allergeni" v-model="check_allergeni">
                          <label v-bind:for="valori.id"><img v-bind:src="valori.immagine" v-bind:class="valori.class"> {{valori.nome}}</label>
                        -->
                      </ul>
                    </p>
                  </div>
                </div>
              </template>
              
              <template #modal-footer="{ cancel }">
                <span style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">CHIUDI</b-button></span>
                <span style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="saveNewActivity()">SALVA</b-button></span>
              </template>
            </b-modal>
          </div>
        </div>
        <div class="col">
            <span class="float-right">
            <div class="search-bar input-group"  @click="searchModalVisible = true">
                <button class="btn btn-link" id="search-button" data-toggle="modal" data-target="#searchModal"><i class="tim-icons icon-zoom-split"></i>
                <span class="d-lg-none d-md-block">Search</span>
                </button>
            </div>
            <modal :show.sync="searchModalVisible"
                class="modal-search"
                id="searchModal"
                :centered="false"
                :show-close="true">
              <input type="text" id="ricerca" class="form-control" v-on:keyup="cerca()" name="ricerca" placeholder=" Cerca...">
            </modal>
            </span>
        </div>
    </div>
    <div class="row" style="margin-top:15px">
      <div class="col">
        <card class="card">
          <div class="table-responsive">
            <table class="table tablesorter" id="tabella" style="text-align: center">
              <thead>
                <tr>
                  <!--<th @click="sort('')" style="text-decoration:underline">Etichette</th>-->
                  <th @click="sort('')" style="text-decoration:underline">Titolo</th>
                  <th @click="sort('')" style="text-decoration:underline">Data Consegna</th>
                  <th @click="sort('')" style="text-decoration:underline">Stato</th>
                  <th @click="sort('')" style="text-decoration:underline">Completamento</th>
                  <th @click="sort('')" style="text-decoration:underline">Categoria</th>
                </tr>
              </thead>
              <tbody>
                <tr><!-- v-for="(valori) in sortedValori" v-bind:key="valori.ID" -->
                  <td>...</td>
                  <td>...</td>
                  <td>...</td>
                  <td>...</td>
                  <td>...</td>
                  <td>...</td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import Card from "@/components/Cards/Card.vue";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    Card,
    Modal,
  },

  data() {
    return {
      //modal
      modalShow: false,
      object: '',
      description: '',
      priority_selected: 'normale',
      status_selected: 'daIniziare',
      checkPrivate: false,
      startDate: null,
      endDate: null,
      percentageComplete: 0,
      reminderCheck: false,
      reminderDate: null,
      //search
      searchModalVisible: false,
      searchQuery: '',
      //page: 1,
      //totPage: null,
      showModal: false,
      check_partecipanti: [],

      saveActivity: null,
      activities: null,
      token_response: null,
      user_livello: '',

      header:{
        headers: {
            'Content-type': 'application/json',
        }
      },
      currentSort:'',
      currentSortDir:'desc',
      urlRichieste: 'https://sviluppoallergeni.confcom.it/',//'https://apiintranet.confcom.it/'
    };
  },

  methods: {
    //TODO
    loadActivity: async function() {
      await axios.get(
        this.urlRichieste + '',
          {
          withCredentials: true,
          headers: {
            'Content-type': 'application/json',
            //'Authorization': `Bearer ${token}`
          }
        }
      ).then(response => { this.activities = response.data})
      console.log("valori activities");
      console.log(this.activities);
    },

    //TODO
    cerca: function() {
      let input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("ricerca");
      filter = input.value.toUpperCase();
      table = document.getElementById("tabella");
      tr = table.getElementsByTagName("tr");
      let arrayFiltrato = [];
      for (i = 0; i < this.activities.length; i++) {
        txtValue = this.activities[i].TITOLO;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          arrayFiltrato.push(this.activities[i]);
        }
      }
      this.activities = arrayFiltrato;
      if (filter == "") {
       // this.caricaPagina();
      }
    },

    getDate(datetime) {
      return moment(String(datetime)).format('DD-MM-YYYY');
    },

    logout: async function () {
      let token = localStorage.getItem('access_token');
      await axios.delete(
        this.urlRichieste + 'logout',
        //'https://sviluppoallergeni.confcom.it/logout',
          {
          withCredentials: true,
          headers: {
            'Content-type': 'application/json',
            //'Authorization': `Bearer ${token}`
          }
        }
      ).then(response => { this.results = response.data})
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.setItem('isLogged', false);
      localStorage.removeItem('user_nome')
      localStorage.removeItem('user_cognome');
      localStorage.removeItem('user_tipologia');
      localStorage.removeItem('user_email');
      localStorage.removeItem('user_livello');
      localStorage.removeItem('user_id');
      this.$router.push({
        path: '/login'
      })
    },

    refreshToken: async function(){
      let errore = 0;
      await axios.post(
        this.urlRichieste + "token",
        {
          withCredentials: true,
          headers: {
            'Content-type': 'application/json',
          }
        }
      ).then(response => { this.token_response = response.data})
      .catch(function (error) {
        if(error.response.status == 403){
          errore = error.response.status;
        }
      })
      if(errore == 403){
        await this.logout();
      }
      localStorage.setItem('access_token', this.token_response.accessToken);
    },

    //TODO
    saveNewActivity: async function() {
      let errore = 0;
      /*await axios.post(
        this.urlRichieste + '',
          {
          withCredentials: true,
          headers: {
            'Content-type': 'application/json',
            //'Authorization': `Bearer ${token}`
          }
        }
      ).then(response => { this.saveActivity = response.data})
      .catch(function (error) {
        if(error.response.status == 401){
          errore = error.response.status;
        }
      })
      if (errore == 401) {
        //refreshToken
      }*/
      console.log("valori salvati");
      console.log(this.saveActivity);
    },

    sort:function(s) {
      //if s == current sort, reverse
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
    },

    main: async function() {
      axios.defaults.withCredentials = true;
      this.user_livello = localStorage.getItem('user_livello');
      this.loadActivity();
    },
  },

  mounted() {
    this.main();
    
  },

  computed:{
     sortedValori:function() {
      return this.activities.sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;
        if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    },
  },

};
</script>
<style scoped>
.senza-punto {
  list-style-type: none;
}
:checked+label::before {
  content: "✓";
  transform: scale(1);
}
:checked+label i{
  transform: scale(0.95);
  z-index: -1;
  filter: none;
}
:checked+label span{
  transform: scale(0.95);
  z-index: -1;
  filter: none;
  color:#1a9f06;
}
input[type="checkbox"][id^="cb"] {
  display: none;
}
/* --------- */

.modal-vue .overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
}

.modal-vue .modal {
  position: relative;
  width: 300px;
  z-index: 9999;
  margin: 0 auto;
  padding: 20px 30px;
  background-color: #fff;
}

.modal-vue .close{
  position: absolute;
  top: 10px;
  right: 10px;
}


.arrow {
  border: solid #00467f;
  border-width: 0 3px 3px 0;
  background: white;
  display: inline-block;
  padding: 7px;
}

.right {
  transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
}

@media screen and (max-width: 500px) {
  .hidemobile {
    display: none;
  }
}
@media screen and (min-width: 500px) {
  .hidecomputer {
    display:  none;
  }
}

body {
  font-family: Roboto,sans-serif;
}
button, input, optgroup, select, textarea {
    font-family: Roboto,sans-serif;
}
</style>
